<label class="form-field__checkbox" (click)="toggleChecked()">
  <fa-icon
    [icon]="isChecked() ? iconChecked : iconUnchecked"
    class="form-field__checkbox-icon"
    [class.form-field__checkbox-icon--checked]="isChecked()"
  ></fa-icon>

  <div>
    <div class="form-field__checkbox-label">
      {{ field?.label ?? '' | translateInline }}
    </div>

    @if (field?.description) {
      <div class="form-field__checkbox-description">
        {{ field?.description ?? '' | translateInline }}
      </div>
    }
  </div>
</label>
